import { sfx } from "../lib/soundEngine";

export const Footer = () => {
    const year = new Date().getFullYear();
    const scrollTop = (e) => {
        e.preventDefault();
        sfx.click();
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer
            data-testid="site-footer"
            className="mt-16 border-t border-white/5"
            style={{ background: "rgba(8, 8, 12, 0.9)" }}
        >
            <div className="max-w-7xl mx-auto px-5 md:px-8 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div>
                    <p className="font-pixel text-xl neon-cyan">
                        © {year} METE&apos;S SITE
                    </p>
                    <p className="text-sm text-gray-500 mt-1 font-body">
                        Coded with neon dust and pixel love · a retro arcade experiment
                    </p>
                </div>
                <div className="flex items-center gap-6">
                    <span className="hidden sm:inline font-pixel text-lg neon-pink">
                        <i className="fa-solid fa-bolt mr-2" /> HIGH VOLTAGE
                    </span>
                    <a
                        href="#top"
                        onClick={scrollTop}
                        data-testid="footer-back-to-top"
                        className="font-pixel text-lg neon-amber hover:opacity-80 transition-opacity"
                    >
                        <i className="fa-solid fa-arrow-up mr-2" />
                        BACK TO TOP
                    </a>
                </div>
            </div>
        </footer>
    );
};
